import { render, staticRenderFns } from "./ReadOnlyInfo.vue?vue&type=template&id=16ce99aa"
import script from "./ReadOnlyInfo.vue?vue&type=script&lang=js"
export * from "./ReadOnlyInfo.vue?vue&type=script&lang=js"
import style0 from "./ReadOnlyInfo.vue?vue&type=style&index=0&id=16ce99aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports